<div class="back-btn text-left d-flex align-items-center">
  <button type="button" (click)="goBack()" class="d-flex align-center mobile-back">
    <i class="fal fa-angle-left" aria-hidden="true"></i>
    <ng-container *ngIf="(breakpointService.isMobile$ | async) === false">
      <ng-container *ngIf="text; else defaultText">
        {{ text | observablePipe | async }}
      </ng-container>

      <ng-template #defaultText>
        {{ 'button.back-to-overview' | translate }}
      </ng-template>
    </ng-container>
  </button>
</div>
